import { useEffect, useState } from 'react';
import type { RouteObject } from 'react-router';
import { Navigate, useParams, useSearchParams } from 'react-router';

import { useSearchContext } from '../providers';

const AuthenticateRedirect = () => {
  const { storeId } = useParams();
  const [searchParams] = useSearchParams();
  const password = searchParams.get('password');
  const queryParams = password ? `?password=${password}` : '';

  return (
    <Navigate
      to={`/stores/${storeId}/authenticate${queryParams}`}
      replace={true}
    />
  );
};

const HomeRedirect = () => {
  const { storeId } = useParams();
  const [searchParams] = useSearchParams();
  const [categoryPath, setCategoryPath] = useState('');
  const { resetSearchState } = useSearchContext();

  useEffect(() => {
    searchParams.forEach((value, key) => {
      if (key.includes('filters') && key.includes('root_types')) {
        setCategoryPath(`/${value}`);
      }
    });

    resetSearchState();
  }, []);

  return (
    <Navigate to={`/stores/${storeId}/menu${categoryPath}`} replace={true} />
  );
};

const LandingRedirect = () => {
  const { storeId } = useParams();

  return <Navigate to={`/stores/${storeId}/landing`} replace={true} />;
};

const PDPRedirect = () => {
  const { storeId, productId } = useParams();

  /**
   * When "closing" a PDP modal, the page navigates backwards.
   * Here we put shove the "All Products" page into the history, otherwise closing the
   * PDP modal takes the user back to a blank page rather than the menu.
   */
  // eslint-disable-next-line @iheartjane/workspace/no-dom-globals-in-react-fc
  window.history.pushState({}, 'menu', `/stores/${storeId}/menu/all`);

  return (
    <Navigate
      to={`/stores/${storeId}/menu/all/products/${productId}`}
      replace={true}
    />
  );
};

const authenticateRedirectRoute: RouteObject = {
  element: <AuthenticateRedirect />,
  path: ':storeSlug/setup-bypass',
};

const homeRedirectRoute: RouteObject = {
  element: <HomeRedirect />,
  path: ':storeSlug/menu',
};

const landingRedirectRoute: RouteObject = {
  element: <LandingRedirect />,
  path: ':storeSlug/landing',
};

const pdpRedirectRoute: RouteObject = {
  element: <PDPRedirect />,
  path: ':storeSlug/products/:productId/:productSlug',
};

export const kioskV1Routes = (): RouteObject => ({
  children: [
    authenticateRedirectRoute,
    homeRedirectRoute,
    landingRedirectRoute,
    pdpRedirectRoute,
  ],
});
